const breakpoints: { [key: string]: string } = {
  sm: '30em', // 480px
  md: '48em', // 768px
  lg: '64em', // 1024px
  xl: '80em', // 1280px
  '2xl': '87.5em', // 1400px
  '3xl': '96em', // 1536px
  '4xl': '108em', // 1728px
};
export default breakpoints;
